/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FilePages16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.686 13.179H4.52l-1.418.63h11.583c.173 0 .314-.14.314-.314v-.002a.314.314 0 00-.314-.314zM2.42 12.653l-.399.683a.158.158 0 00.216.216l.683-.399-.5-.5zM2.653 12.256l.664.664c.049.05.124.06.185.028a7.674 7.674 0 001.863-1.368l3.427-3.427L7.42 6.781l-3.427 3.427a7.675 7.675 0 00-1.368 1.863.158.158 0 00.028.185zM9.107 7.838a.158.158 0 00.223 0l.785-.804c4.412-4.413 4.727-5.516 4.333-5.91-.394-.393-1.497-.078-5.909 4.334l-.804.785a.158.158 0 000 .223l1.372 1.372z"
            fill={vars.bdlGray50}
        />
    </AccessibleSVG>
);

export default FilePages16;
